import React from 'react';
import { Dialog } from '@economic/taco';
import { t, Trans } from '@lingui/macro';
import gifPensoPay from '~/app/pages/market/onboarding/CustomerPayments/assets/PensoPay.gif';
import DialogFooter from '~/app/pages/market/onboarding/CustomerPayments/components/DialogFooter';

const AwaitingPensoPay = () => {
    return (
        <Dialog open size="xs">
            <Dialog.Content className="flex flex-col" aria-label={t`TOAST_LOADING`}>
                <Dialog.Title>
                    <Trans>Connecting with pensopay...</Trans>
                </Dialog.Title>
                <div className="flex w-2/3 mt-12 mb-6 self-center">
                    <img src={gifPensoPay} alt="" />
                </div>
                <DialogFooter />
            </Dialog.Content>
        </Dialog>
    );
};

export default AwaitingPensoPay;
